import * as Yup from 'yup';

import { FIELD_IS_NUMERIC_STRING, FIELD_IS_REQUIRED } from 'src/common/validation/errors';
import type { SpecificationMeasureUnit } from 'src/types/reference/SpecificationMeasureUnit';

export type SpecificationDimensionsPopupFormValuesItem = {
  measureUnit: SpecificationMeasureUnit | null;

  length: number | null;
  width: number | null;
  height?: number | null;
};

export type SpecificationDimensionsPopupFormValues = {
  values: SpecificationDimensionsPopupFormValuesItem[];
};

export const specificationDimensionsPopupFormItemValidationSchema = (
  is3d: boolean
): Yup.ObjectSchema<SpecificationDimensionsPopupFormValuesItem, SpecificationDimensionsPopupFormValuesItem> =>
  Yup.object<SpecificationDimensionsPopupFormValuesItem>()
    .shape({
      measureUnit: Yup.mixed<SpecificationMeasureUnit>().required(FIELD_IS_REQUIRED).default(null),

      length: Yup.number().typeError(FIELD_IS_NUMERIC_STRING).required(FIELD_IS_REQUIRED).default(null),
      width: Yup.number().typeError(FIELD_IS_NUMERIC_STRING).required(FIELD_IS_REQUIRED).default(null),

      height: Yup.number()
        .nullable()
        .when({
          is: () => is3d,
          then: (schema) => schema.typeError(FIELD_IS_NUMERIC_STRING).required(FIELD_IS_REQUIRED),
          otherwise: (schema) => schema.notRequired(),
        })
        .default(null),
    })
    .required(FIELD_IS_REQUIRED);

export const specificationDimensionsPopupFormValidationSchema = (is3d: boolean) =>
  Yup.object<SpecificationDimensionsPopupFormValues>().shape({
    values: Yup.array().of(specificationDimensionsPopupFormItemValidationSchema(is3d)),
  });
